import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { ReactComponent as Approval } from 'assets/svgs/approve-outline-20.svg';
import { IconWrapper } from 'components/atoms/icon-shell/icon-shell';
import { RbacButton } from 'components/organisms/rbac/components/rbac-buttons';
import { useProjectAsRBACResource } from 'hooks/rbac/useWithAccess';
import { useTranslation } from 'hooks/use-translation';

interface Props {
  onClick: () => void;
  projectId: number;
}
export const AskForApprovalBtn: FC<Props> = ({ onClick, projectId }) => {
  const tooltip = useTranslation('document.req_approval_tooltip');

  return (
    <Tooltip title={tooltip} placement="bottom">
      <RbacButton
        type="text"
        icon={
          <IconWrapper>
            <Approval />
          </IconWrapper>
        }
        size="small"
        onClick={onClick}
        // rule="DOCUMENT_APPROVAL:CREATE"
        rule="DOCUMENT:READ"
        resourceData={useProjectAsRBACResource(projectId)}
      />
    </Tooltip>
  );
};
